import { render, staticRenderFns } from "./ExhibitionTags.vue?vue&type=template&id=c0a13e3e&"
import script from "./ExhibitionTags.vue?vue&type=script&lang=js&"
export * from "./ExhibitionTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports